import { BusinessIndicator, UpdateBusinessIndicator } from '@/entities/businessIndicator';
import { Api } from './api/axios-config';

export class BusinessAttachmentService{
  private static api = Api();

  public static async getBusinessAttachments(businessId: number){
    const response = await this.api.get<any>(`att/getAtt/${businessId}`);
    if(response.status === 200){
      return response.data;
    }
  }

  public static async deleteBusinessAttachments(id:number){
    const response = await this.api.delete<any>(`att/delete/${id}`);
    if(response.status === 201){
      return response.data;
    }
  }

  public static async attachmentPreview(id: number){
    try {
      const response = await this.api.get(`/att/preview/${id}`, { responseType: 'blob' });

      if(response.status === 200){
        return response.data;
      } 
    } catch (error) {
      console.error('Erro ao carregar o preview:', error);
    }
  }
  
}
